import {useCallback, useContext, useEffect, useState} from "react";
import {UserContext} from "./UserContext";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const Messages = () =>{
    const{access_token,initializing,backEndUrl} = useContext(UserContext)
    const[messages,setMessages] = useState(null)
    const[loading,setLoading] = useState("")
    const[error,setError] = useState("")
    const [selectedMessage,setSelectedMessage] = useState(null)
    const navigate = useNavigate()
    const GetMessages = useCallback(async () =>{
        setLoading("Please wait as we retrieve your messages....")
        setError("")
        try{
            if (!access_token){
                setLoading("")
                setError("You dont have permission to access this page either try to login to the first")
                navigate("/signin")
                return
            }

            const response = await axios.get(`${backEndUrl}/get_messages`,{headers:{Authorization:`Bearer ${access_token}`}})
            const revResponse = response.data.slice(0).reverse()
            setMessages(revResponse)
            setLoading("")
        } catch (error){
            setLoading("")
            setError(error.message)
        }
    },[access_token, backEndUrl, navigate])

    useEffect(()=>{
        if(initializing){
            setLoading("Please wait the as the application is loading....")
        }else {
            GetMessages()
        }
    },[initializing, GetMessages])

    const DeleteMessage = async (message_id) =>{
        if(!access_token){
            setLoading("You dont have permission to access this page.")
            return
        }
        if (!message_id){
            setError("No message selected")
            return
        }
        try{
            setLoading("Deleting message....")
            const formData = new FormData()
            formData.append("messageId",message_id)

            const response = await axios.post(`${backEndUrl}/delete_message`,formData,{headers:{Authorization:`Bearer ${access_token}`}})
            setLoading(response.data.message)
            setMessages(prevMessages =>prevMessages?.filter(msg=> msg.message_id !== message_id) || [])
            if(selectedMessage?.message_id === message_id){
                setSelectedMessage(null)
            }

        }catch (error){
            setLoading("")
            setError(error.message)
        }

    }

    const DeleteAllMessages = async () =>{
        if(!access_token){
            setLoading("You dont have permission to access this page.")
            return
        }

        try{
            setLoading("Please wait as we process your request...")
            const response = await axios.post(`${backEndUrl}/delete_all_messages`,{},{headers:{Authorization:`Bearer ${access_token}`}})
            setLoading(response.data.message)
            if (response.data.message === "All messages have been deleted successfully"){
                setMessages(null)
            }

        }catch (error){
            setError(error.message)

        }

    }
    return(
        <>
            <section className="section">
                <div className="section-container">
                    <div className="section-header">
                        <p className="eyebrow">Inbox</p>
                        <h2>Messages from your network</h2>
                        <p className="body-text">Reply directly from your preferred channel. Delete sensitive info once handled.</p>
                    </div>
                    {error && <div className="status-banner danger">{error}</div>}
                    {loading && <div className="status-banner info">{loading}</div>}
                    {messages?.length > 0 ?
                        <div className="message-board">
                            <div className="message-actions">
                                <button className="btn btn-secondary" onClick={GetMessages}>Refresh messages</button>
                                <button className="btn btn-danger" onClick={DeleteAllMessages}>Delete all</button>
                            </div>
                            <div className="message-grid">
                                {messages.map((msg)=>(
                                    <article className="message-card" key={msg.message_id}>
                                        <header>
                                            <p className="message-name">{msg.full_name}</p>
                                            <span className="badge">{msg.phone_number}</span>
                                        </header>
                                        <p className="message-preview">{msg.message_sent.length > 120 ? `${msg.message_sent.substring(0,120)}…` : msg.message_sent}</p>
                                        <div className="message-card-actions">
                                            <button className="btn btn-ghost" onClick={()=>setSelectedMessage(msg)}>View</button>
                                            <button className="btn btn-danger" onClick={()=>DeleteMessage(msg.message_id)}>Delete</button>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                        :
                        <div className="empty-state">
                            <p className="empty-title">No messages yet</p>
                            <p className="body-text">Once a visitor reaches out, the note will appear here instantly.</p>
                            <button className="btn btn-secondary" onClick={GetMessages}>Refresh inbox</button>
                        </div>




                    }

                </div>

            </section>

            {selectedMessage && (
                <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Full message">
                    <div className="modal-panel">
                        <button className="modal-close" onClick={()=>setSelectedMessage(null)} aria-label="Close message">×</button>
                        <div className="modal-body">
                            <div className="modal-content">
                                <p className="eyebrow">Sender</p>
                                <h3>{selectedMessage.full_name}</h3>
                                <p className="body-text">Phone: {selectedMessage.phone_number}</p>
                                <p className="body-text">Message:</p>
                                <p className="message-full">{selectedMessage.message_sent}</p>
                                <div className="modal-actions">
                                    <button className="btn btn-danger" onClick={()=>DeleteMessage(selectedMessage.message_id)}>Delete</button>
                                    <button className="btn btn-ghost" onClick={()=>setSelectedMessage(null)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    )


}


export default Messages;

